// Auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

// Tasks
export const TASK_LOAD = "TASK_LOAD";
export const ADD_TASK = "ADD_TASK";
